module.exports = __webpack_public_path__ + "static/media/invite_friend.c9817449.png";